import Seo from '@/components/base/Seo';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import Ticker from './components/Ticker';
import Categories from './components/Categories';
import LatestComics from './components/LatestComics';
import Featured from './components/Featured';
import Trending from './components/Trending';
import Testimonials from './components/Testimonials';
import Faq from './components/Faq';
import Cta from './components/Cta';
import { faqs } from '@/mocks/faqs';

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '歪歪漫画',
  url: typeof window !== 'undefined' ? window.location.origin : '',
  description: '韩国歪歪漫画恶搞反转神展开脑洞魔性爆笑漫画合集，每日更新热门恶搞漫画，分类清晰。',
  inLanguage: 'zh-CN',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${typeof window !== 'undefined' ? window.location.origin : ''}/category?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export default function Home() {
  return (
    <>
      <Seo
        title="韩国歪歪漫画 - 恶搞反转神展开脑洞魔性爆笑漫画合集"
        description="歪歪漫画汇聚韩国歪歪漫画最恶搞的题材与反转剧情，神展开脑洞魔性爆笑，每日更新热门恶搞漫画，分类清晰快速找到你想看的作品入口。"
        keywords="韩国歪歪漫画,韩国歪歪漫画恶搞,韩国歪歪漫画反转,韩国歪歪漫画神展开,韩国歪歪漫画脑洞,韩国歪歪漫画魔性,韩国歪歪漫画爆笑"
        canonicalPath="/"
        jsonLd={[orgJsonLd, faqJsonLd]}
      />
      <Navbar />
      <main>
        <Hero />
        <Ticker />
        <Categories />
        <LatestComics />
        <Featured />
        <Trending />
        <Testimonials />
        <Faq />
        <Cta />
      </main>
      <Footer />
    </>
  );
}